'use strict';

var customSwal = require('./customSwal');

/**
 * Reads toast copy and cart URL from page-level data attributes.
 *
 * @returns {{ cartUrl: string, message: string, ctaLabel: string }}
 */
function getConfig() {
	var $root = $('[data-cart-show-url]').first();

	return {
		cartUrl: $root.attr('data-cart-show-url') || '',
		message: $root.attr('data-added-to-cart-message') || '',
		ctaLabel: $root.attr('data-added-to-cart-btn') || '',
	};
}

/**
 * Formats a localized toast label with the current cart quantity.
 *
 * @param {string} template
 * @param {number} quantityTotal
 * @returns {string}
 */
function formatCtaLabel(template, quantityTotal) {
	if (!template) {
		return '';
	}

	if (template.indexOf('{0}') !== -1) {
		return template.replace('{0}', quantityTotal);
	}

	return template;
}

/**
 * Builds the add-to-cart toast markup.
 *
 * @param {{ message?: string, quantityTotal?: number, cartUrl?: string, ctaLabel?: string, error?: boolean }} payload
 * @returns {string}
 */
function buildHtml(payload) {
	var isError = !!payload.error;
	var message = payload.message || '';
	var iconClass = isError ? 'icon-close' : 'icon-check';
	var statusModifier = isError ? ' sa-add-to-cart-toast--error' : '';
	var ctaHtml = '';

	if (!isError && payload.cartUrl) {
		var ctaLabel = formatCtaLabel(payload.ctaLabel, payload.quantityTotal);
		ctaHtml = '<a class="btn btn--primary sa-add-to-cart-toast__cta" href="' + payload.cartUrl + '">' + ctaLabel + '</a>';
	}

	return (
		'<div class="sa-add-to-cart-toast' +
		statusModifier +
		'" role="status" aria-live="polite">' +
		'<div class="sa-add-to-cart-toast__status">' +
		'<span class="sa-add-to-cart-toast__icon" aria-hidden="true">' +
		'<i class="' +
		iconClass +
		'"></i>' +
		'</span>' +
		'<p class="sa-add-to-cart-toast__message">' +
		message +
		'</p>' +
		'</div>' +
		ctaHtml +
		'</div>'
	);
}

/**
 * Opens the add-to-cart toast; replaces any visible SweetAlert2 instance first.
 *
 * @param {{ message?: string, quantityTotal?: number, cartUrl?: string, ctaLabel?: string, error?: boolean }} payload
 * @returns {Promise}
 */
function show(payload) {
	if (customSwal.Swal.isVisible()) {
		customSwal.Swal.close();
	}

	var toastConfig = getConfig();
	var resolvedPayload = Object.assign({}, payload, {
		cartUrl: payload.cartUrl || toastConfig.cartUrl,
		ctaLabel: payload.ctaLabel || toastConfig.ctaLabel,
		message: payload.error ? payload.message : payload.message || toastConfig.message,
	});

	return customSwal.openToast({
		html: buildHtml(resolvedPayload),
	});
}

module.exports = {
	show: show,
};
